import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/power-calculator',
  component: () => import('../../routes/PowerCalculator.svelte'),
  card: {
    id: 'power-calculator',
    title: 'Power Calculator',
    description: 'Calculate power, force, or velocity using P = F × v. Enter any two values to find the third.',
    icon: 'electric_bolt',
    iconBgClass: 'bg-yellow-50',
    iconTextClass: 'text-yellow-600',
    href: '/power-calculator',
    category: 'Physics & Science',
  },
  seo: {
    title: 'Power Calculator – Calculate Power, Force & Velocity | P = Fv',
    description:
      'Free power calculator to find power, force, or velocity using P = F × v. Solves for any variable given the other two. Includes real-world examples and energy calculations.',
  },
};

export default meta;
